module.exports = __webpack_public_path__ + "img/service15.31120cb2.svg";